import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type entriesDataType = {
  id: string;
  errorCallback: Function;
  resultKey?: string;
};

export default ({ id, errorCallback, resultKey = 'entriesData' }: entriesDataType) =>
  requestAsync({
    url: endpoints.getEntriesUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getEntriesUrl(id),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
